<template>
  <section class="wrapper">
    <van-search shape="round" placeholder="请输入您要查询的公司名称" show-action v-model="queryStr" @search="searchCompany"
                @cancel="cancelSearch"/>
    <div class="company-list">
      <p class="company-item" v-for="(item,index) in companyList" :key="index" @click="choose(item)">{{item.Name}}</p>
    </div>
  </section>
</template>

<script>
  import {getCompanyListApi} from '@/api/company'

  export default {
    name: "search",
    data() {
      return {
        queryStr: '',
        companyList: [],
      }
    },
    mounted: function () {
      this.searchCompany()
    },
    methods: {
      //取消搜索
      cancelSearch() {
        this.$refs.input = '';
        this.$router.push('/company')
      },
      //搜索
      async searchCompany() {
        let params = {
          CompanyName: this.queryStr,
          loginName: this.getCookie('UserInfo').TelName
        };
        let response = await getCompanyListApi(params);
        if (response.success) {
          this.companyList = response.result;
        }
      },
      //选择公司
      choose(company) {
        this.setCookie('CompanyInfo',{
          ...company,
          // companyName: company.Name
        });
        this.$router.push('/home')
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    overflow: hidden;

    .company-list {
      height: calc(100vh - 10rem);
      overflow-y: auto;
      overflow-x: hidden;

      .company-item {
        height: 3.6rem;
        line-height: 3.6rem;
        padding: 0 1rem;
        border-bottom: 1px solid #dcdcdc;
      }
    }
  }

</style>
